import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=5930a79a"
import script from "./Feedbacks.vue?vue&type=script&lang=js"
export * from "./Feedbacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports